import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../App';
import LanguageDropdown from './LanguageDropdown';
import CookieBanner from './CookieBanner';

const PublicLayout = ({ children }) => {
  const { t, i18n } = useTranslation();
  const { token } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-6">
          <Link to="/">
            <img src="/idemenu-logo.svg" alt="idemenu" className="h-10 w-auto" />
          </Link>

          <div className="flex items-center gap-4">
            <LanguageDropdown />
            <button 
              onClick={() => window.location.href = token ? '/admin' : '/login'}
              className="px-6 py-2 bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-200 rounded-lg font-medium text-purple-700 hover:bg-indigo-100 transition-colors"
            >
              {token
                ? t('footer.admin', i18n.language === 'en' ? 'Admin' : 'Yönetici')
                : t('footer.login', i18n.language === 'en' ? 'Login' : 'Giriş Yap')}
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-16 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Brand */}
            <div>
              <img src="/idemenu-footer-logo.svg" alt="idemenu" className="h-10 w-auto mb-4 brightness-0 invert" />
              <p className="text-gray-400">
                {t('footer.tagline')}
              </p>
            </div>
            
            {/* Ürün */}
            <div>
              <h4 className="text-white font-semibold mb-4">{t('footer.product')}</h4>
              <ul className="space-y-2">
                <li><Link to="/features" className="hover:text-white transition-colors">{t('footer.features')}</Link></li>
                <li><Link to="/pricing" className="hover:text-white transition-colors">{t('footer.pricing')}</Link></li>
              </ul>
            </div>
            
            {/* Şirket */}
            <div>
              <h4 className="text-white font-semibold mb-4">{t('footer.company')}</h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="hover:text-white transition-colors">{t('footer.about')}</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors">{t('footer.contact')}</Link></li>
              </ul>
            </div>
            
            {/* Hukuki */}
            <div>
              <h4 className="text-white font-semibold mb-4">{t('footer.legal')}</h4>
              <ul className="space-y-2">
                <li><Link to="/terms" className="hover:text-white transition-colors">{t('footer.terms')}</Link></li>
                <li><Link to="/kvkk" className="hover:text-white transition-colors">{t('footer.kvkk')}</Link></li>
                <li><Link to="/cookies" className="hover:text-white transition-colors">{t('footer.cookies')}</Link></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-3 text-gray-500">
            <p>{t('footer.copyright')}</p>
            <span className="hidden sm:inline text-gray-700">·</span>
            <a
              href="https://idepark.com/studio.html"
              aria-label={t('footer.studioMarkAria')}
              className="text-[12px] text-gray-600 hover:text-gray-400 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded"
            >
              {t('footer.studioMark')}
            </a>
          </div>
        </div>
      </footer>

      {/* Cookie Banner */}
      <CookieBanner 
        context="public" 
        language={i18n.language}
        t={t}
      />
    </div>
  );
};

export default PublicLayout;
